import React from 'react';
import { SummaryPoint } from '../types';
import { Clock } from 'lucide-react';

interface TimelineProps {
  points: SummaryPoint[];
}

export const Timeline: React.FC<TimelineProps> = ({ points }) => {
  return (
    <div className="relative">
      {/* Vertical Line */}
      <div className="absolute left-6 top-4 bottom-4 w-0.5 bg-slate-100"></div>

      <div className="space-y-6">
        {points.map((item, index) => (
          <div key={index} className="relative flex gap-6 group">
            {/* Timestamp Badge */}
            <div className="flex-shrink-0 z-10">
              <div className="w-12 h-12 rounded-2xl bg-white border border-slate-100 shadow-sm flex flex-col items-center justify-center text-xs font-bold text-slate-600 group-hover:scale-110 transition-transform duration-300 group-hover:border-blue-200 group-hover:shadow-blue-100">
                <Clock size={12} className="mb-1 text-slate-400" />
                {item.timestamp}
              </div>
            </div>

            {/* Content Card */}
            <div className="flex-1 bg-white p-4 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow">
              <p className="text-slate-700 text-sm leading-relaxed">{item.point}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};